import { TypeLeagueVolunteerRole } from '@/GeneratedTypes/TypeLeagueVolunteerRole'

export function roleById(id: number, roles: TypeLeagueVolunteerRole[]) {
  return roles.find((x) => x.id == id)
}
